var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[_c('cache-clear-modal'),_vm._v(" "),_c('notification-marquee'),_vm._v(" "),_c('v-main',{staticClass:"pt-0"},[_c('snackbar'),_vm._v(" "),_c('v-lazy',{staticClass:"fill-height"},[_c('transition',{attrs:{"name":"slide-fade","duration":550}},[_c('nuxt')],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }